import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { AttestationState } from './state';

const defaultState: AttestationState = {
  attestations: [],
};

export const attestationModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
